<template functional>
  <div
    class="font-weight-bold"
    :class="$options.headerClassFor(props)"
    :style="$options.headerStyleFor(props)">
    <template v-if="props.col.sortBy">
      <a href="" @click.prevent="$options.handleClick(listeners, props)">
        {{ $options.labelFor(props) }}
        <i
          class="fa fa-fw"
          :class="{
            'fa-sort text-secondary': props.col.sortBy != props.sortedBy,
            'fa-sort-down': props.col.sortBy === props.sortedBy && props.sortOrder && props.sortOrder.toUpperCase() === 'DESC',
            'fa-sort-up': props.col.sortBy === props.sortedBy && props.sortOrder && props.sortOrder.toUpperCase() === 'ASC',
          }">
        </i>
      </a>
    </template>
    <template v-else>
      {{ $options.labelFor(props) }}
      <i class="fa fa-fw"></i>
    </template>
  </div>
</template>
<script>
import startCase from 'lodash/startCase';
import { resolveFn } from 'core/utils';

export default {
  functional: true,

  props: {
    col: {
      type: Object,
      required: true
    },

    sortedBy: {
      type: String,
      default: undefined
    },

    sortOrder: {
      type: String,
      default: undefined
    },

    stacked: {
      type: Boolean,
      default: false
    }
  },

  headerClassFor(props) {
    const col = props.col;
    if (props.stacked) {
      return 'col text-right';
    }
    return resolveFn(col.styleClass, { col }) || 'col';
  },

  headerStyleFor(props) {
    const col = props.col;
    if (props.stacked) {
      return undefined;
    }
    return resolveFn(col.style, { col }) || 'col';
  },

  labelFor(props) {
    const col = props.col;
    if (col.label) {
      return resolveFn(col.label);
    }

    return startCase(col.key);
  },

  handleClick(listeners, props) {
    if (props.col.sortBy && listeners && listeners.sort) {
      if (props.sortedBy === props.col.sortBy) {
        listeners.sort(props.col.sortBy, props.sortOrder === 'ASC' ? 'DESC' : 'ASC');
      } else {
        listeners.sort(props.col.sortBy, 'ASC');
      }
    }
  },

  isSorted(props) {
    return props.col.sortBy && props.sortedBy && props.sortedBy === props.col.sortBy;
  }
};
</script>
